"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = Component;
const React = __importStar(require("react"));
const LocalElements = __importStar(require("../../elements"));
function Component(props) {
    const result = props.result;
    const warnings = result.warnings;
    if (!props.isExpanded) {
        return null;
    }
    return (React.createElement(LocalElements.NodeList, null,
        !!warnings.length && React.createElement(WarningNode, { name: "Warning", warnings: warnings }),
        result.nodes.map(n => (React.createElement(NodeOrLeaf, { nodeOrLeaf: n, key: n.id, path: [], toggleExpand: props.toggleExpand })))));
}
function NodeOrLeaf(props) {
    switch (props.nodeOrLeaf.type) {
        case "leaf":
            return React.createElement(Leaf, { leaf: props.nodeOrLeaf });
        case "node":
            return (React.createElement(Node, { node: props.nodeOrLeaf, path: props.path, toggleExpand: props.toggleExpand }));
        default:
            throw new Error("Unknown type");
    }
}
function Node(props) {
    return (React.createElement("li", null,
        React.createElement(LocalElements.NodeHeader, { onClick: () => props.toggleExpand([...props.path, props.node.id]) },
            React.createElement(LocalElements.NodeExpander, null, props.node.expanded ? "-" : "+"),
            props.node.ok ? (React.createElement(LocalElements.NodeImage, { src: "/assets/images/errors/ok.svg" })) : (React.createElement(LocalElements.NodeImage, { src: "/assets/images/errors/error.svg" })),
            React.createElement(LocalElements.NodeTitle, null, props.node.name)),
        props.node.expanded && (React.createElement("ul", null, props.node.children.map((c, ix) => (React.createElement(NodeOrLeaf, { nodeOrLeaf: c, key: ix, path: [...props.path, props.node.id], toggleExpand: props.toggleExpand })))))));
}
function WarningNode(props) {
    const [isExpanded, toggleExpanded] = React.useState(false);
    return (React.createElement("li", null,
        React.createElement(LocalElements.NodeHeader, { onClick: () => toggleExpanded(!isExpanded) },
            React.createElement(LocalElements.NodeExpander, null, isExpanded ? "-" : "+"),
            React.createElement(LocalElements.NodeImage, { src: "/assets/images/component-messages/warning.png" }),
            React.createElement(LocalElements.NodeTitle, null, props.name)),
        isExpanded && (React.createElement("ul", null, props.warnings.map(x => (React.createElement("li", null, x)))))));
}
function Leaf(props) {
    return (React.createElement("li", null,
        React.createElement(LocalElements.CompareTable, null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Ref"),
                    React.createElement("td", null, props.leaf.stringifyValues(props.leaf.ref))),
                React.createElement("tr", null,
                    React.createElement("th", null, "Test"),
                    React.createElement("td", null, props.leaf.stringifyValues(props.leaf.test))))))
    // <>
    //   <li>{props.leaf.ref}</li>
    //   <li>{props.leaf.test}</li>
    // </>
    );
}
//# sourceMappingURL=test-node-renderer.js.map